import { StyleSheet } from 'react-native';

export const extraStyles = StyleSheet.create({

  extraTitle: {
    marginHorizontal: 5,
    marginTop: 10,
    fontSize: 16,
    fontWeight: 800,
  },
  extraPic: {
    height: 60,
    width: 60,
    resizeMode: 'cover',
    borderRadius: 10,
    backgroundColor: '#808080',
    marginTop: 10,
  },
  extraWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  extraLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    flexBasis: 200,
    // backgroundColor: 'green',
  },
  extraname: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 10,
  },

  extraname2: {
    fontSize: 10,
    color: 'grey',
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 10,
  },

  priceWrapper: {
    display: 'flex',
    textAlign: 'left',
    flexBasis: 80,
    width: 90,
   
  },

  extraprice: {
    color: 'orange',
    fontWeight: 'bold',
  
  },
});
